import styled from 'styled-components';

export const ImageComparisonList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ImageComparison = styled.div`
  width: 49%;
  overflow:hidden;
  border: 2px solid #333;
  margin-bottom: 20px;

  @media (max-width: 992px) {
    width: 100%;
    margin-bottom:20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/PhotoEditingPortfolio.style.js